import { ConfigProvider, Table } from 'antd';
import { useEffect, useRef } from 'react';
import { ScaleLoader } from 'react-spinners';
import '../Common/Table/table.css';

const InfiniteTable = ({
    columns,
    data,
    loading,
    onRowClick,
    rowSelection,
    scroll,
    className,
    fetchMoreData,
    hasMore,
    id,
}) => {

    const tableRef = useRef(null);

    useEffect(() => {
        // Attach scroll listener to the table body
        const tableBody = tableRef.current?.querySelector('.ant-table-body');

        const handleScroll = (e) => {
            const { scrollTop, scrollHeight, clientHeight } = e.target;
            // Check if scrolled to bottom with some threshold
            if (scrollHeight - scrollTop <= clientHeight + 50) {
                if (hasMore && !loading) {
                    fetchMoreData();
                }
            }
        };

        if (tableBody) {
            tableBody.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (tableBody) {
                tableBody.removeEventListener('scroll', handleScroll);
            }
        };
    }, [hasMore, loading, fetchMoreData, data]); // Re-attach if data changes to ensure we have the latest closure

    // Reuse the same renderEmpty from props or default
    const renderEmpty = () => <div className="p2 center-text">No Data Found</div>;

    return (
        <div className={`paycraft-table container-table ${className}`} ref={tableRef} id={id}>
            <ConfigProvider renderEmpty={renderEmpty}>
                <Table
                    rowKey="id"
                    columns={columns}
                    dataSource={data}
                    onRow={(record) => {
                        return {
                            onClick: (event) => onRowClick && onRowClick(event, record),
                        };
                    }}
                    loading={
                        loading && data.length === 0 // Only show main loader if initial load
                            ? {
                                indicator: (
                                    <div className="table-loader">
                                        <ScaleLoader color="#262626" />
                                    </div>
                                ),
                            }
                            : false
                    }
                    pagination={false} // Disable default pagination
                    scroll={scroll} // Pass scroll prop (important for sticky headers and scroll body)
                    rowSelection={rowSelection}
                />
            </ConfigProvider>
            {loading && data.length > 0 && (
                <div style={{ textAlign: 'center', padding: '10px' }}>
                    <ScaleLoader color="#262626" height={15} />
                </div>
            )}
        </div>
    );
};

export default InfiniteTable;
